import { render, staticRenderFns } from "./morph.vue?vue&type=template&id=5375b274&"
import script from "./morph.vue?vue&type=script&lang=js&"
export * from "./morph.vue?vue&type=script&lang=js&"
import style0 from "./morph.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5375b274', component.options)
    } else {
      api.reload('5375b274', component.options)
    }
    module.hot.accept("./morph.vue?vue&type=template&id=5375b274&", function () {
      api.rerender('5375b274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/morph.vue"
export default component.exports